<div *ngIf="isLoading|async" class="overlay">
  <p-progressSpinner strokeWidth="2" styleClass="custom-spinner">
  </p-progressSpinner>
</div>